var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 21",
    style: {
      enableBackground: "new 0 0 19 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#fff;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    transform: "translate(4771.248 366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    className: "st0",
    d: "M-4769.7-359.8l1.1,12.8c0.1,0.9,0.9,1.6,1.8,1.7h9.8c0.9,0,1.7-0.7,1.8-1.7l1.1-12.8H-4769.7z  M-4764.9-347.7c-0.3,0-0.6-0.2-0.6-0.6l-0.6-9.7c0-0.3,0.2-0.6,0.6-0.6c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0l0.6,9.7 C-4764.3-348-4764.6-347.8-4764.9-347.7C-4764.9-347.7-4764.9-347.7-4764.9-347.7z M-4761.3-348.3c0,0.3-0.3,0.6-0.6,0.6 c-0.3,0-0.6-0.3-0.6-0.6c0,0,0,0,0,0v-9.7c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0,0,0,0,0V-348.3z M-4757.7-358l-0.6,9.7 c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6l0.6-9.7c0-0.3,0.3-0.6,0.6-0.6C-4758-358.6-4757.7-358.3-4757.7-358 C-4757.7-358-4757.7-358-4757.7-358z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    transform: "translate(4770 360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    className: "st0",
    d: "M-4752.9-357.4h-3.6v-0.6c0-1-0.8-1.8-1.8-1.8h-4.8c-1,0-1.8,0.8-1.8,1.8v0.6h-3.6 c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h15.6c0.7,0,1.2-0.5,1.2-1.2C-4751.7-356.9-4752.2-357.4-4752.9-357.4z  M-4757.7-357.4h-6v-0.6c0-0.3,0.3-0.6,0.6-0.6h4.8c0.3,0,0.6,0.3,0.6,0.6V-357.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconWhite);
export default __webpack_public_path__ + "static/media/delete-icon-white.eebe600194434c9b5a06a7cc22049971.svg";
export { ForwardRef as ReactComponent };